import React from "react";
import Metadata from "@/components/Metadata";
import { createClient } from "../../prismicio";
import TermsAndConditionsBlog from "@/components/TermsAndConditions";
import Layout from "@/components/Layout";

function TermsAndConditions({ page, globals }) {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/terms-and-conditions"
      />
      <TermsAndConditionsBlog
        title={pageData?.title}
        description={pageData?.description}
      />
    </Layout>
  );
}

export default TermsAndConditions;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("terms_and_conditions");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
